/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { updateIntl } from 'react-intl-redux';
import FastClick from 'fastclick';
import {
  FormattedMessage,
  injectIntl,
} from 'react-intl';
import i18n from 'lorai18n';
import config from 'loracfg';
import CSSModules from 'react-css-modules';
import ConsoleNavbar from './coms/ConsoleNavbar';
import styles from './styles/main.scss';

const defaultProps = {
  locale: localStorage.getItem('language') || 'zh',
};

const propTypes = {
  updateIntl: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  pathname: PropTypes.string.isRequired,
  push: PropTypes.func.isRequired,
  locale: PropTypes.string,
  children: PropTypes.node.isRequired,
};

class App extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      menus: this.menus(),
      pathname: props.pathname,
    };
  }

  componentWillMount() {
    const { locale, pathname, intl } = this.props;
    const lc = intl.locale || locale || 'zh';
    this.props.updateIntl({
      locale: lc,
      messages: i18n[lc],
    });
    try {
      localStorage.setItem('language', lc);
    } catch (e) {
      // do nothing
    }
    this.props.push(pathname, {});
  }

  componentDidMount() {
    FastClick.attach(document.body);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.pathname !== this.props.pathname) {
      this.setState({
        pathname: nextProps.pathname,
      });
    }
  }

  menus() {
    const locale = this.props.intl.locale;
    let menus = [{
      link: '/overview',
      name: <FormattedMessage id="lora.nav.overview" />,
    }, {
      link: '/gateway',
      name: <FormattedMessage id="lora.nav.gateway" />,
    }, {
      link: '/application',
      name: <FormattedMessage id="lora.nav.application" />,
    }, {
      link: '/network',
      name: <FormattedMessage id="lora.nav.network" />,
    }, {
      link: `/static/docs/${locale}/index.html`,
      static: true,
      name: <FormattedMessage id="lora.nav.documentation" />,
    }];

    if (config.profile === 'cube') {
      menus = _.filter(menus, m => m.link !== '/billing');
    }
    return menus;
  }

  render() {
    const { pathname, menus } = this.state;

    return (
      <div styleName="app">
        <ConsoleNavbar
          menus={menus}
          pathname={pathname}
        />
        <div styleName="app-body" style={{ minHeight: window.innerHeight }}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

App.propTypes = propTypes;
App.defaultProps = defaultProps;

const mapStateToProps = (state, ownProps) => ({
  pathname: ownProps.location.pathname,
  locale: ownProps.location.query.locale,
});

const mapDispatchToProps = dispatch => ({
  updateIntl,
  push: (...args) => dispatch(push(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  injectIntl(CSSModules(App, styles)));




// WEBPACK FOOTER //
// ./src/containers/App/index.jsx